<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-06-27 16:19:44
 * @LastEditors: Sephiroth·D·Kid
 * @LastEditTime: 2020-05-08 14:17:29
 * @Description: 联系我们
 -->

<template>
  <div class="contact-wrapper">
    <div class="content">
      <p class="title">客服服务</p>
      <p class="item">投诉电话：10102015</p>
      <p class="item">客服邮箱：KF@jinr.com</p>
    </div>
    <div class="content">
      <p class="title">公司战略合作</p>
      <p class="item">商务合作：BD@jinr.com</p>
      <p class="item">媒体采访：PR@jinr.com</p>
    </div>
    <div class="content">
      <p class="title">公司机构</p>
      <p class="item">公司总部：厦门吉才神网络借贷信息中介服务有限公司</p>
      <p class="item">总部地址：中国(福建)自由贸易试验区厦门片区嵩屿南二路99号1335室</p>
      <p class="item">邮编：361000</p>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="less" scope>
.contact-wrapper {
  padding: 40px;
  .content {
    margin-bottom: 40px;
    .title {
      font-weight: 600;
      margin-bottom: 20px;
      font-size: 18px;
    }
    .item {
      line-height: 40px;
    }
  }
}
</style>
